import { Link } from 'react-router-dom';
import { homepageArticles } from '@/mocks/home';

export default function ArticleSection() {
  return (
    <section className="py-20 md:py-28 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between mb-16 gap-4">
          <div>
            <p className="text-primary-500 font-heading text-sm tracking-[0.2em] mb-3">风月文章</p>
            <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-900">
              笔墨之间的风月情怀
            </h2>
          </div>
          <Link
            to="/category/yuexia-fengliu"
            className="whitespace-nowrap inline-flex items-center gap-2 text-sm text-foreground-500 hover:text-primary-500 transition-colors group"
          >
            浏览全部文章
            <i className="ri-arrow-right-line group-hover:translate-x-1 transition-transform" />
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
          {homepageArticles.map((article) => (
            <Link
              key={article.id}
              to={`/article/${article.id}`}
              className="group bg-background-50 border border-background-200/70 rounded-lg overflow-hidden hover:border-primary-200/50 transition-all duration-300"
            >
              <div className="aspect-[16/10] overflow-hidden">
                <img
                  src={article.imageUrl}
                  alt={article.title}
                  className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                />
              </div>
              <div className="p-5">
                <div className="flex items-center gap-3 mb-3">
                  <span className="text-xs px-2.5 py-0.5 rounded-full bg-accent-100 text-accent-700 font-medium whitespace-nowrap">
                    {article.category}
                  </span>
                  <span className="text-xs text-foreground-400">{article.date}</span>
                  <span className="text-xs text-foreground-400">{article.readTime}</span>
                </div>
                <h3 className="font-heading text-lg font-semibold text-foreground-900 mb-2 line-clamp-2 group-hover:text-primary-600 transition-colors">
                  {article.title}
                </h3>
                <p className="text-foreground-500 text-sm leading-relaxed line-clamp-2">
                  {article.excerpt}
                </p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}